import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Approach',
    href: '#approach'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal-950/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-203" data-mp="1py1kzs5xrm71">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-204" data-mp="9opypi81ux4t">
        <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight" data-id="element-205" data-mp="enkfyfqdcdmt">
          McLean <span className="text-amber-500" data-id="element-206" data-mp="jm448msfq1ic">PT</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-207" data-mp="olgnyyo0esgp">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-offwhite-100 hover:text-amber-500 transition-colors text-sm font-medium" data-id="element-208" data-mp="3n3w1ogpcbdnx">
              {link.name}
            </a>)}
          <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-6 py-2.5 rounded-full font-semibold transition-all transform hover:scale-105" data-id="element-209" data-mp="uky473467c3">
            Book a Consult
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-offwhite-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-210" data-mp="318x1l9awz7ao">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-211" data-mp="3azrqymjgin0c" /> : <MenuIcon size={28} data-id="element-212" data-mp="3b0b65vhq2xao" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-213" data-mp="362i51gva0th9">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal-900 border-t border-charcoal-800" data-id="element-214" data-mp="2ibvunixsux43">
            <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-215" data-mp="7kchpniwkhg9">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-offwhite-100 hover:text-amber-500 text-lg font-medium py-2" data-id="element-216" data-mp="2ljecnxby6tt">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 text-charcoal-950 px-6 py-3 rounded-lg font-semibold text-center mt-4" data-id="element-217" data-mp="155nhyouf5re">
                Book a Consult
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}